module.exports = __webpack_public_path__ + "img/8-9.b137b0fa.png";